//@flow

import {
  PORT_KEY_ADMIN,
  PORT_KEY_ADMIN_SSL,
  PORT_KEY_SERVER,
} from 'state/types/serverTypes';
import type { Ports } from 'state/types/serverTypes';
import RSAKey from 'portfolio-shared/lib/encrypt';
import type { PublicKeyInfo } from 'state/types/authTypes';

export const DEFAULT_PORT_DEV = '3000';
export const DEFAULT_PORT_SERVER = '8090';
export const DEFAULT_PORT_ADMIN = '8091';

export const GLOBAL_SETTING = {
  CREATE_AUTOSYNC_FOLDER: 'server.create.autosync.folder',
  DEFAULT_USER_ACCESS_LEVEL: 'client.default.user.access.level',
  FOLDER_AUTOSYNC: 'server.default.autosync.folder',
  FOLDER_LOGS_DEFAULT: 'server.default.logging.dir',
  FOLDER_PREVIEWS: 'server.default.previews.folder',
  FOLDER_PREVIEWS_DEFAULT: 'server.default.default.previews.folder',
  FOLDER_VAULT: 'server.vault.home',
  FOLDER_VAULT_DEFAULT: 'server.vault.home.default',
  FOLDER_WORK: 'server.work.folder',
  FOLDER_WORK_DEFAULT: 'server.default.work.folder',
  FOLDER_WORK_TRANSITIONAL: 'server.work.folder.transitional',
  MOBILE_UPLOADS_ENABLED: 'mobile.uploads.enabled',
  MOBILE_UPLOADS_FOLDER: 'default.upload.folder',
  MOBILE_UPLOADS_CATALOG: 'mobile.uploads.catalog',
  SAVE_PREVIEWS: 'server.save.previews',
  SSO_PRINCIPAL: 'server.sso.principal',
  SSO_KEY: 'server.sso.key',
};

export function getAdminAddress(ports: Ports) {
  // TODO: this should be a selector
  let serverAddress = window.location.protocol + '//' + window.location.host;
  // handle dev mode
  const segments = serverAddress.split(':');
  if (segments[segments.length - 1] === DEFAULT_PORT_DEV) {
    const addressWithoutPort = segments.slice(0, segments.length - 1).join(':');
    const port = (ports && ports[PORT_KEY_ADMIN]) || DEFAULT_PORT_ADMIN;
    serverAddress = addressWithoutPort + ':' + port;
  }
  return serverAddress;
}

export function getAdminAddressAfterPortChange(url: URL, ports: Ports): string {
  let result: URL = url;
  if (url.protocol === 'https:' && ports[PORT_KEY_ADMIN_SSL]) {
    result.port = String(ports[PORT_KEY_ADMIN_SSL]);
  }
  if (url.protocol === 'http:' && ports[PORT_KEY_ADMIN]) {
    result.port = String(ports[PORT_KEY_ADMIN]);
  }
  return `${result.protocol}//${result.hostname}:${result.port}/`;
}

export function getMainServerPort(ports: Ports) {
  return (ports && ports[PORT_KEY_SERVER]) || DEFAULT_PORT_SERVER;
}

export function encrypt(password: string, publicKeyInfo: ?PublicKeyInfo) {
  const rsakey = new RSAKey();
  const exponent = Number(publicKeyInfo && publicKeyInfo.exponent).toString(16);

  rsakey.setPublic(publicKeyInfo && publicKeyInfo.modulusBase16, exponent);

  return rsakey.encrypt_b64(password);
}



// WEBPACK FOOTER //
// ./src/util/serverUtils.js